import type { ILoan } from "@/modules/loan/common/types";
import { LoanRepaymentStatus } from "@/modules/transaction/common/enum";
import { CloudflareAsset } from "@/shared/common/enums";
import { Amount, CloudFlareImage } from "@/shared/components";
import { Divider } from "@ab.uitools/ui-library/components/Divider";
import { components } from "@ab.uitools/ui-library/components/ReactSelect";
import type { OptionProps, TOption } from "@ab.uitools/ui-library/components/ReactSelect/types";
import { Text } from "@ab.uitools/ui-library/components/Text";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

export const LoanSelectOption = (props: OptionProps<TOption>) => {
  const { t } = useTranslation();
  const {
    index,
    loanType,
    currency,
    interestRate,
    loanRepaymentStatus,
    principalAmount,
  } = props.data.meta as ILoan & { index: number };
  return (
    <components.Option {...props}>
      <div className="flexbox align-items--center loan-option-item">
        <div
          className={classNames(
            `loan-info--icon flexbox align-items--center justify-content--center`,
            {
              "loan-info--icon-danger": loanRepaymentStatus === LoanRepaymentStatus.Overdue
            }
          )}>
          <CloudFlareImage
            size="small"
            path={
              loanRepaymentStatus === LoanRepaymentStatus.Overdue ?
                CloudflareAsset.LoanDangerLight :
                CloudflareAsset.Loan
            }
          />
        </div>
        <div className="pl-12 mb-12 full-width">
          {!!index && (
            <Divider
              color="light"
              type="primary"
              isHorizontal
            />
          )}
          <div className="flexbox align-items-center">
            <div className="pt-12 full-width">
              <div className="flexbox align-items--center justify-content--between">
                <Text weight="semibold">{t(loanType)}</Text>
                <Amount size="standard" currency={currency} amount={principalAmount}/>
              </div>
              <div className="flexbox flex-wrap--wrap">
                <Text type="tertiary">
                  {props.data.value} • {interestRate}%
                </Text>
                {loanRepaymentStatus === LoanRepaymentStatus.Overdue && (
                  <>
                    <Text className="px-4" type="tertiary">•</Text>
                    <Text type="danger-light">
                      {t("transfer.loanRepayment.overdue")}
                    </Text>
                  </>
                )}
              </div>
            </div>
            <div className="flexbox align-items--center">
              {props.isSelected && (
                <CloudFlareImage
                  className="ml-4"
                  size="small"
                  path={CloudflareAsset.SelectedOption}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </components.Option>
  );
};
